import React, { Component } from 'react';
import '../../App.css';
import Gallery from 'react-grid-gallery'
import Footer from '../reusables/footer'

const IMAGES =
[{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/20.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/20.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/21.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/21.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/22.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/22.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/19.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498006/Pioricost/Plantaci%C3%B3n/19.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/15.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/15.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/18.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/18.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/16.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/16.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/8.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/8.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/13.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/13.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/17.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/17.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/14.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/14.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/12.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/12.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/10.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498005/Pioricost/Plantaci%C3%B3n/10.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/7.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/7.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/9.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/9.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/11.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/11.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/4.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/4.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/3.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/3.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/2.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/2.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/1.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/1.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/6.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/6.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/5.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498004/Pioricost/Plantaci%C3%B3n/5.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
}]

const IMAGES2 =
[{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/7.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/7.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/6.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/6.jpg",
  thumbnailWidth: 320,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/5.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/5.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/4.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/4.jpg",
  thumbnailWidth: 320,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/3.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/3.jpg",
  thumbnailWidth: 230,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/2.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/2.jpg",
  thumbnailWidth: 230,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/1.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498021/Pioricost/Centro%20de%20acopio/1.jpg",
  thumbnailWidth: 280,
  thumbnailHeight: 212
}]

const IMAGES3 =
[{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/17.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/17.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/16.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/16.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/15.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/15.jpg",
  thumbnailWidth: 200,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/14.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/14.jpg",
  thumbnailWidth: 380,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/13.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/13.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/12.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/12.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/11.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/11.jpg",
  thumbnailWidth: 300,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/10.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/10.jpg",
  thumbnailWidth: 320,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/9.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/9.jpg",
  thumbnailWidth: 300,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/8.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/8.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/7.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/7.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/6.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/6.jpg",
  thumbnailWidth: 320,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/5.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/5.jpg",
  thumbnailWidth: 250,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/4.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/4.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/3.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/3.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/2.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/2.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
},
{
  src: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/1.jpg",
  thumbnail: "https://res.cloudinary.com/dcbmvfiwz/image/upload/v1561498036/Pioricost/Producto%20final/1.jpg",
  thumbnailWidth: 150,
  thumbnailHeight: 212
}]

class Vivir extends Component {
  render() {
    return (
      <div className="Vivir">

        <div className="vivir-container">
          <span>Плантация</span>
          <Gallery images={IMAGES} enableImageSelection={false}/>
          <span>Центр Заготовки</span>
          <Gallery images={IMAGES2} enableImageSelection={false}/>
          <span>Готовый продукт</span>
          <Gallery images={IMAGES3} enableImageSelection={false}/>
          <span>Видео</span>
          <iframe width="980" height="605" src="https://www.youtube.com/embed/Sbe7FT0kh3w" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Vivir;


// WEBPACK FOOTER //
// ./src/components/ru-vivir/index.js